import axios from "axios";
import { Config } from "@/configs/config";
const httpClient = axios.create({
  baseURL: Config.BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Since your app uses credentials
});

export default httpClient;
